import { useContext } from "react"
import { UserContext } from "./contexts/UserContext";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { Dashboard } from "./pages/desktop/Dashboard";
import { SinistrosPage } from "./pages/desktop/Sinistros";
import { PericiasPage } from "./pages/desktop/Pericias";
import { SolicitacoesPage } from "./pages/desktop/Solicitacoes";
import { MinhasTarefas } from "./pages/desktop/MinhasTarefas";
import { NovaSolicitacao } from "./pages/desktop/NovaSolicitacao";
import { TimeSheetPage } from "./pages/desktop/TimeSheet";
import { TimeSheetPIPage } from "./pages/desktop/TimeSheetPI";
import { TimeSheetDetalhesPage } from "./pages/desktop/TimeSheetDetalhes";
import { TimeSheetPIDetalhesPage } from "./pages/desktop/TimeSheetPIDetalhes";
import { TimeSheetDetalhesPagePdf } from "./pages/desktop/TimeSheetDetalhesPdf";
import { WIPPage } from "./pages/desktop/WIP";
import { WipContabilPage } from "./pages/desktop/WIPContabil";
import { WIPDetalhesPage } from "./pages/desktop/WIPDetalhes";
import { WIPHistoricoPage } from "./pages/desktop/WIPHistorico";
import { Login } from "./pages/desktop/Login";
import { LoginRecover } from "./pages/desktop/LoginRecover";
import { ListagemAprovacoesPage } from "./pages/desktop/ListagemAprovacoes";
import { MeritocraciaPage } from "./pages/desktop/Meritocracia";
import { LancamentosTSPage } from "./pages/desktop/LancamentosTS";
import { AvisosPage } from "./pages/desktop/AvisosNotificacoes";
import { OrdensDeServicoPage } from "./pages/desktop/OrdensDeServico";
import { NotasFiscaisPage } from "./pages/desktop/NotasFiscais";
import { ProgramasPmePage } from "./pages/desktop/PmePrograma";
import { ProgramasFormPmePage } from "./pages/desktop/PmeProgramaForm";
import { ResultadosPmePage } from "./pages/desktop/PmeResultados";
import { ResultadosProgramaPmePage } from "./pages/desktop/PmeResultadosPrograma";
import { PerfilPmePage } from "./pages/desktop/PmePerfil";
import { TopFeeMakerPmePage } from "./pages/desktop/PmeTopFeeMaker";
import { TopFeeMakerResultPmePage } from "./pages/desktop/PmeTopFeeMakerResult";
import { WIPDiarioPage } from "./pages/desktop/WIPDiario";
import { WIPMensalPage } from "./pages/desktop/WIPMensal";
import { ProjetoInternoPage } from "./pages/desktop/ProjetoInterno";
import { VisibilidadePage } from "./pages/desktop/Visibilidade";

const PrivateRoute = ({ component: Component, authed, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => authed === true
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />}
        />
    )
}

export const Routes = () => {
    const { authed } = useContext(UserContext);
    return (
        <Router>
            <Switch>
                <Route path="/login" exact component={Login} />
                <Route
                    path="/login-recover"
                    exact
                    component={LoginRecover}
                />
                <PrivateRoute authed={authed} exact path="/dashboard" component={Dashboard} />
                <PrivateRoute authed={authed} exact path="/wip" component={WIPPage} />
                <PrivateRoute authed={authed} exact path="/wip/contabil" component={WipContabilPage} />
                <PrivateRoute authed={authed} exact path="/wip/detalhes" component={WIPDetalhesPage} />
                <PrivateRoute authed={authed} exact path="/wip/diario" component={WIPDiarioPage} />
                <PrivateRoute authed={authed} exact path="/wip/mensal" component={WIPMensalPage} />
                <PrivateRoute authed={authed} exact path="/wip/historico" component={WIPHistoricoPage} />
                <PrivateRoute authed={authed} exact path="/avisos" component={AvisosPage} />
                <PrivateRoute authed={authed} exact path="/sinistros" component={SinistrosPage} />
                <PrivateRoute authed={authed} exact path="/pericias" component={PericiasPage} />
                <PrivateRoute authed={authed} exact path="/solicitacoes" component={SolicitacoesPage} />
                <PrivateRoute authed={authed} exact path="/timesheet" component={TimeSheetPage} />
                <PrivateRoute authed={authed} exact path="/timesheet-pi" component={TimeSheetPIPage} />
                <PrivateRoute authed={authed} exact path="/timesheetdetalhespage" component={TimeSheetDetalhesPage} />
                <PrivateRoute authed={authed} exact path="/timesheetpidetalhespage" component={TimeSheetPIDetalhesPage} />
                <PrivateRoute authed={authed} exact path="/timesheetdetalhespagepdf" component={TimeSheetDetalhesPagePdf} />
                <PrivateRoute authed={authed} exact path="/nova-solicitacao" component={NovaSolicitacao} />
                <PrivateRoute authed={authed} exact path="/minhas-tarefas" component={MinhasTarefas} />
                <PrivateRoute authed={authed} exact path="/aprovacoes" component={ListagemAprovacoesPage} />
                <PrivateRoute authed={authed} exact path="/meritocracia" component={MeritocraciaPage} />
                <PrivateRoute authed={authed} exact path="/lancamentosts" component={LancamentosTSPage} />
                <PrivateRoute authed={authed} exact path="/ordens-de-servico" component={OrdensDeServicoPage} />
                <PrivateRoute authed={authed} exact path="/notas-fiscais" component={NotasFiscaisPage} />
                <PrivateRoute authed={authed} exact path="/pme-programas" component={ProgramasPmePage} />
                <PrivateRoute authed={authed} exact path="/pme-programas/novo" component={ProgramasFormPmePage} />
                <PrivateRoute authed={authed} exact path="/pme-programas/edit/:idPrograma" component={ProgramasFormPmePage} />
                <PrivateRoute authed={authed} exact path="/pme-resultados" component={ResultadosPmePage} />
                <PrivateRoute authed={authed} exact path="/pme-resultados/programa/:idPrograma" component={ResultadosProgramaPmePage} />
                <PrivateRoute authed={authed} exact path="/pme-perfis" component={PerfilPmePage} />
                <PrivateRoute authed={authed} exact path="/pme-top-fee-maker" component={TopFeeMakerPmePage} />
                <PrivateRoute authed={authed} exact path="/pme-top-fee-maker/:idPrograma" component={TopFeeMakerResultPmePage} />
                
                <PrivateRoute authed={authed} exact path="/projetos-internos" component={ProjetoInternoPage} />

                <PrivateRoute authed={authed} exact path="/visibilidade" component={VisibilidadePage} />

                <PrivateRoute authed={authed} exact path="/" component={Dashboard} />
                <PrivateRoute authed={authed} path="*" render={() => <Redirect to="/" />} />
            </Switch>
        </Router>
    )
}